<mat-spinner *ngIf="!isDataAvailable" style="align-content: center"></mat-spinner>
<!--<mat-progress-bar *ngIf="!isDataAvailable" mode="determinate" value="{{valueSpinner}}"></mat-progress-bar>-->
 <table mat-table [dataSource]="dataSource">
  <ng-container *ngFor="let disCol of headTotalElements; let colIndex = index" matColumnDef="{{disCol}}">
    <mat-header-cell fxFlex="230px" *matHeaderCellDef>{{disCol}}</mat-header-cell>
    <mat-cell [title]="disCol" *matCellDef="let element "> {{element[disCol]}}
    </mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="headTotalElements"></mat-header-row>
  <mat-row *matRowDef="let row; columns: headTotalElements;"></mat-row>
  
</table> 
<mat-toolbar>
<mat-toolbar-row style="background-color: #FFFFFF">
    <button mat-fab color="primary" aria-label="Example icon button with a home icon" matTooltip="Scarica in un file excel"  (click)="exportAsXLSX()">
      <mat-icon>arrow_downward</mat-icon>
    </button>
    <span class="example-spacer"></span>
    <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                   [length]="totalSize"
                   [pageSize]="5"
                   (page)="handlePage($event)">showFirstLastButtons></mat-paginator>
  </mat-toolbar-row>
</mat-toolbar>
